import React, { useMemo } from 'react';
import { useRouter } from "next/router";
import CustomLink from "../../components/UI/CustomLink";
import Accordion from "../../components/UI/Accordion";
import helpers from "../../helpers/helpers";
import { useSelector } from "react-redux";
import MetaTags from '../../components/MetaTags/MetaTags';

const Faq = () => {
    const router = useRouter();

    const { getTranslationText } = helpers;

    const { language } = useSelector((state) => state.language);

    const getContextForTab = (router) => {
        switch (router?.query?.section) {
            case 'about':
                return [{ title: getTranslationText('faq.about_nft'), data: getTranslationText('faq.about_nft_context') }];
                break;
            case 'registration':
                return [{ title: getTranslationText('faq.registration_how'), data: getTranslationText('faq.registration_how_context') }];
                break;
            case 'deposit-withdraw':
                return [
                    { title: getTranslationText('faq.deposit-withdraw_wallets'), data: getTranslationText('faq.deposit-withdraw_wallets_context') },
                    { title: getTranslationText('faq.deposit-withdraw_withdraw'), data: getTranslationText('faq.deposit-withdraw_withdraw_context') },
                    { title: getTranslationText('faq.deposit-withdraw_deposit'), data: getTranslationText('faq.deposit-withdraw_deposit_context') },
                ];
            case 'btt':
                return [{ title: getTranslationText('faq.btt'), data: getTranslationText('faq.btt_context') }];
                break;
            case 'deals':
                return [
                    { title: getTranslationText('faq.deals_buy'), data: getTranslationText('faq.deals_buy_context') },
                ];
                break;
            case 'auction':
                return [
                    { title: 'faq.auction_how', data: getTranslationText('faq.auction_how_context') },
                ];
                break;
            default:
                return [];
        }
    };

    const title = useMemo(() => {
        switch (router.query.section) {
            case 'about':
                return getTranslationText('faq.title_about');
            case 'registration':
                return getTranslationText('faq.title_registration');
            case 'deposit-withdraw':
                return getTranslationText('faq.title_depo/withdr');
            case 'btt':
                return getTranslationText('faq.title_btt');
            case 'deals':
                return getTranslationText('faq.title_deals');
            case 'auction':
                return getTranslationText('faq.title_auction');
            default:
                return '';    

        }
    }, [router.query.section, language]);

    return (
        <>
            <MetaTags
                metaTitle={title}
                metaDescription={title}
            />
            {language && <div className="faq__wrapper">
                <div className={'faq__left'}>
                    <h2>FAQ</h2>
                    <div className={'tabs_list'}>
                        <CustomLink
                            className={`link ${router.query.section === 'about' ? 'active' : ''}`}
                            href='/faq/[section]'
                            as='/faq/about'>
                            {getTranslationText('faq.title_about')}
                        </CustomLink>
                        <CustomLink className={`link ${router.query.section === 'registration' ? 'active' : ''}`}
                            href='/faq/[section]'
                            as='/faq/registration'>
                            {getTranslationText('faq.title_registration')}
                        </CustomLink>
                        <CustomLink className={`link ${router.query.section === 'deposit-withdraw' ? 'active' : ''}`}
                            href='/faq/[section]'
                            as='/faq/deposit-withdraw'>
                            {getTranslationText('faq.title_depo/withdr')}
                        </CustomLink>
                        <CustomLink className={`link ${router.query.section === 'btt' ? 'active' : ''}`} href='/faq/[section]'
                            as='/faq/btt'>
                            {getTranslationText('faq.title_btt')}
                        </CustomLink>
                        <CustomLink className={`link ${router.query.section === 'deals' ? 'active' : ''}`} href='/faq/[section]'
                            as='/faq/deals'>
                            {getTranslationText('faq.title_deals')}
                        </CustomLink>
                        <CustomLink className={`link ${router.query.section === 'auction' ? 'active' : ''}`}
                            href='/faq/[section]'
                            as='/faq/auction'>
                            {getTranslationText('faq.title_auction')}
                        </CustomLink>
                    </div>
                </div>
                <div className={'faq__right'}>
                    <Accordion items={getContextForTab(router)} />
                </div>
            </div>}
        </>
    )
}

export default Faq;